import script from "./UniversalViewerWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalViewerWrapper.vue?vue&type=script&setup=true&lang=js"

import "./UniversalViewerWrapper.vue?vue&type=style&index=0&id=e51976e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e51976e2"]])

export default __exports__